import { render, staticRenderFns } from "./PreregistrationCreate.vue?vue&type=template&id=7ed67e13&scoped=true"
import script from "./PreregistrationCreate.vue?vue&type=script&lang=js"
export * from "./PreregistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./PreregistrationCreate.vue?vue&type=style&index=0&id=7ed67e13&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed67e13",
  null
  
)

export default component.exports